import { render, staticRenderFns } from "./WordImportPage.vue?vue&type=template&id=758813dc&scoped=true"
import script from "./WordImportPage.vue?vue&type=script&lang=js"
export * from "./WordImportPage.vue?vue&type=script&lang=js"
import style0 from "./WordImportPage.vue?vue&type=style&index=0&id=758813dc&prod&lang=scss&scoped=true"
import style1 from "./WordImportPage.vue?vue&type=style&index=1&id=758813dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758813dc",
  null
  
)

export default component.exports